import {FocusEventHandler, FormEventHandler} from 'react';
import {Form} from 'react-bootstrap';
import clsx from 'clsx';

interface TextInputControlledProps {
    name: string;
    value: string;
    label: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: FocusEventHandler;
    onReset: FormEventHandler | undefined;
    touched: boolean | undefined;
    errors: string | undefined;
    maxLength?: number;
    disabled?: boolean;
    required?: boolean;
}

const TextInputControlled = ({
    name,
    value,
    label,
    onChange,
    onBlur,
    onReset,
    touched,
    errors,
    maxLength,
    disabled,
    required = true,
}: TextInputControlledProps): JSX.Element => {
    return (
        <Form.Group controlId={name}>
            <Form.Label className="fw-bold fs-3 required">{label}</Form.Label>
            <Form.Control
                name={name}
                value={value}
                className={clsx(
                    {'is-invalid': touched && errors},
                    {'is-valid': touched && !errors}
                )}
                type="text"
                onChange={onChange}
                onBlur={onBlur}
                onReset={onReset}
                maxLength={maxLength}
                disabled={disabled}
                aria-required={required}
                aria-invalid={!!(touched && errors)}
                aria-describedby={touched && errors ? `${name}-error` : undefined}
            />
            {touched && errors && (
                <div id={`${name}-error`} className="fv-plugins-message-container">
                    <div className="fv-help-block">
                        <span role="alert">{errors}</span>
                    </div>
                </div>
            )}
        </Form.Group>
    );
};

export default TextInputControlled;
